"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodInsertPrizeOrder = exports.zodSelectPrizeOrder = exports.zodInsertPromoPrizeReward = exports.zodSelectPromoPrizeReward = exports.zodInsertPromoCodeRecurring = exports.zodSelectPromoCodeRecurring = exports.zodInsertPromoCode = exports.zodSelectPromoCode = exports.zodInsertProductCatalog = exports.zodSelectProductCatalog = exports.zodInsertPrizeTier = exports.zodSelectPrizeTier = exports.zodInsertPrize = exports.zodSelectPrize = exports.zodInsertPlayerPreferences = exports.zodSelectPlayerPreferences = exports.zodInsertPlayerIPAddressLog = exports.zodSelectPlayerIPAddressLog = exports.zodInsertPlayer = exports.zodSelectPlayer = exports.zodInsertPaymentRequest = exports.zodSelectPaymentRequest = exports.zodInsertOrder = exports.zodSelectOrder = exports.zodInsertIntegratedGiftCard = exports.zodSelectIntegratedGiftCard = exports.zodInsertFeedback = exports.zodSelectFeedback = exports.zodInsertEmail = exports.zodSelectEmail = exports.zodInsertDrawTypePlanPrizeTier = exports.zodSelectDrawTypePlanPrizeTier = exports.zodInsertDrawTypePlan = exports.zodSelectDrawTypePlan = exports.zodInsertDrawType = exports.zodSelectDrawType = exports.zodInsertDrawSchedule = exports.zodSelectDrawSchedule = exports.zodInsertDrawOrderSchedulePlan = exports.zodSelectDrawOrderSchedulePlan = exports.zodInsertDrawOrder = exports.zodSelectDrawOrder = exports.zodInsertDraw = exports.zodSelectDraw = exports.zodInsertActivityFeedItem = exports.zodSelectActivityFeedItem = exports.zodInsertAccountJournal = exports.zodSelectAccountJournal = exports.zodInsertAccount = exports.zodSelectAccount = void 0;
exports.zodInsertTokenRedemptionOption = exports.zodSelectTokenRedemptionOption = exports.zodInsertTokenRedemption = exports.zodSelectTokenRedemption = exports.zodInsertTokenOrder = exports.zodSelectTokenOrder = exports.zodInsertTicketEntry = exports.zodSelectTicketEntry = exports.zodInsertTicket = exports.zodSelectTicket = exports.zodInsertTreeLog = exports.zodSelectTreeLog = exports.zodInsertSubscriptionRun = exports.zodSelectSubscriptionRun = exports.zodInsertSubscriptionHistory = exports.zodSelectSubscriptionHistory = exports.zodInsertSubscription = exports.zodSelectSubscription = exports.zodInsertPrizeWin = exports.zodSelectPrizeWin = exports.zodInsertPrizeOrderProduct = exports.zodSelectPrizeOrderProduct = void 0;
const zod_1 = require("zod");
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
exports.zodSelectAccount = zod_1.z.object({
    playerId: zod_1.z.string(),
    currencyCode: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    mainBalance: zod_1.z.number(),
    giftCardBalance: zod_1.z.number(),
    promoBalance: zod_1.z.number(),
    tokenBalance: zod_1.z.number(),
});
exports.zodInsertAccount = zod_1.z.object({
    playerId: zod_1.z.string(),
    currencyCode: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    mainBalance: zod_1.z.number().optional(),
    giftCardBalance: zod_1.z.number().optional(),
    promoBalance: zod_1.z.number().optional(),
    tokenBalance: zod_1.z.number().optional(),
});
exports.zodSelectAccountJournal = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    playerId: zod_1.z.string(),
    totalFiatAmount: zod_1.z.number(),
    balanceAmount: zod_1.z.number(),
    giftCardAmount: zod_1.z.number(),
    promoAmount: zod_1.z.number(),
    paymentMethodAmount: zod_1.z.number(),
    tokenAmount: zod_1.z.number(),
    transactionType: zod_1.z.nativeEnum(dbEnums_1.TransactionType),
    comment: zod_1.z.string().nullable(),
    refType: zod_1.z.nativeEnum(dbEnums_1.PaymentRefType),
    refId: zod_1.z.string(),
    paymentMethod: zod_1.z.nativeEnum(dbEnums_1.PaymentMethod).nullable(),
    paymentSessionId: zod_1.z.string().nullable(),
    internal: zod_1.z.boolean(),
    migrationRef: zod_1.z.string().nullable(),
});
exports.zodInsertAccountJournal = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    playerId: zod_1.z.string(),
    totalFiatAmount: zod_1.z.number(),
    balanceAmount: zod_1.z.number(),
    giftCardAmount: zod_1.z.number(),
    promoAmount: zod_1.z.number(),
    paymentMethodAmount: zod_1.z.number(),
    tokenAmount: zod_1.z.number(),
    transactionType: zod_1.z.nativeEnum(dbEnums_1.TransactionType),
    comment: zod_1.z.string().nullable().optional(),
    refType: zod_1.z.nativeEnum(dbEnums_1.PaymentRefType),
    refId: zod_1.z.string(),
    paymentMethod: zod_1.z.nativeEnum(dbEnums_1.PaymentMethod).nullable().optional(),
    paymentSessionId: zod_1.z.string().nullable().optional(),
    internal: zod_1.z.boolean().optional(),
    migrationRef: zod_1.z.string().nullable().optional(),
});
exports.zodSelectActivityFeedItem = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    lastModified: zod_1.z.coerce.date(),
    actionCode: zod_1.z.string(),
    playerId: zod_1.z.string(),
    refId: zod_1.z.string().nullable(),
    refKey: zod_1.z
        .enum(['prize_win', 'feedback', 'token_order', 'token_redemption'])
        .nullable(),
    displayString: zod_1.z.string().nullable(),
    placeholderData: zod_1.z.unknown().nullable(),
});
exports.zodInsertActivityFeedItem = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    lastModified: zod_1.z.coerce.date().optional(),
    actionCode: zod_1.z.string(),
    playerId: zod_1.z.string(),
    refId: zod_1.z.string().nullable().optional(),
    refKey: zod_1.z
        .enum(['prize_win', 'feedback', 'token_order', 'token_redemption'])
        .nullable()
        .optional(),
    displayString: zod_1.z.string().nullable().optional(),
    placeholderData: zod_1.z.unknown().nullable().optional(),
});
exports.zodSelectDraw = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    drawScheduleId: zod_1.z.number(),
    drawDate: zod_1.z.coerce.date().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.DrawStatus),
    name: zod_1.z.string(),
    numEntries: zod_1.z.number(),
    description: zod_1.z.string().nullable(),
    pendingResult: zod_1.z.unknown().nullable(),
    result: zod_1.z.unknown().nullable(),
    simulatedWinners: zod_1.z.unknown().nullable(),
    verified: zod_1.z
        .enum(['SENT', 'VERIFIED'])
        .nullable(),
    prizesAwardedAt: zod_1.z.coerce.date().nullable(),
    winnersNotified: zod_1.z.boolean().nullable(),
    participantsNotified: zod_1.z.boolean().nullable(),
    prizeId: zod_1.z.number().nullable(),
});
exports.zodInsertDraw = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    drawScheduleId: zod_1.z.number(),
    drawDate: zod_1.z.coerce.date().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.DrawStatus).optional(),
    name: zod_1.z.string(),
    numEntries: zod_1.z.number().optional(),
    description: zod_1.z.string().nullable().optional(),
    pendingResult: zod_1.z.unknown().nullable().optional(),
    result: zod_1.z.unknown().nullable().optional(),
    simulatedWinners: zod_1.z.unknown().nullable().optional(),
    verified: zod_1.z
        .enum(['SENT', 'VERIFIED'])
        .nullable()
        .optional(),
    prizesAwardedAt: zod_1.z.coerce.date().nullable().optional(),
    winnersNotified: zod_1.z.boolean().nullable().optional(),
    participantsNotified: zod_1.z.boolean().nullable().optional(),
    prizeId: zod_1.z.number().nullable().optional(),
});
exports.zodSelectDrawOrder = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    orderId: zod_1.z.string(),
    playerId: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.DrawOrderStatus),
    price: zod_1.z.number(),
    firstDrawId: zod_1.z.number().nullable(),
    drawTypeCode: zod_1.z.string(),
    entries: zod_1.z.unknown(),
});
exports.zodInsertDrawOrder = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    orderId: zod_1.z.string(),
    playerId: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.DrawOrderStatus).optional(),
    price: zod_1.z.number(),
    firstDrawId: zod_1.z.number().nullable().optional(),
    drawTypeCode: zod_1.z.string(),
    entries: zod_1.z.unknown(),
});
exports.zodSelectDrawOrderSchedulePlan = zod_1.z.object({
    drawOrderId: zod_1.z.string(),
    drawScheduleId: zod_1.z.number(),
    drawTypePlanId: zod_1.z.number(),
});
exports.zodInsertDrawOrderSchedulePlan = zod_1.z.object({
    drawOrderId: zod_1.z.string(),
    drawScheduleId: zod_1.z.number(),
    drawTypePlanId: zod_1.z.number(),
});
exports.zodSelectDrawSchedule = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    templateName: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    code: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.DrawScheduleStatus),
    drawTypeCode: zod_1.z.string(),
    schedule: zod_1.z.string().nullable(),
    autoRun: zod_1.z.boolean().nullable(),
    verificationScheme: zod_1.z
        .enum(['INSURED'])
        .nullable(),
    futureDrawCount: zod_1.z.number(),
    prizeStructureId: zod_1.z.number(),
    rotatePrize: zod_1.z.boolean(),
    allowManualDrawCreation: zod_1.z.boolean(),
});
exports.zodInsertDrawSchedule = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    templateName: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    code: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.DrawScheduleStatus).optional(),
    drawTypeCode: zod_1.z.string(),
    schedule: zod_1.z.string().nullable().optional(),
    autoRun: zod_1.z.boolean().nullable().optional(),
    verificationScheme: zod_1.z
        .enum(['INSURED'])
        .nullable()
        .optional(),
    futureDrawCount: zod_1.z.number(),
    prizeStructureId: zod_1.z.number(),
    rotatePrize: zod_1.z.boolean().optional(),
    allowManualDrawCreation: zod_1.z.boolean().optional(),
});
exports.zodSelectDrawType = zod_1.z.object({
    code: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    name: zod_1.z.string(),
    gameType: zod_1.z.nativeEnum(dbEnums_1.GameType),
    numberSetup: dbJsonModels_1.ZDrawTypeNumberSetup.nullable(),
    entryCap: zod_1.z.number().nullable(),
    maxPlayerEntries: zod_1.z.number().nullable(),
    group: zod_1.z.string().nullable(),
    dispOrder: zod_1.z.number(),
});
exports.zodInsertDrawType = zod_1.z.object({
    code: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    name: zod_1.z.string(),
    gameType: zod_1.z.nativeEnum(dbEnums_1.GameType),
    numberSetup: dbJsonModels_1.ZDrawTypeNumberSetup.nullable().optional(),
    entryCap: zod_1.z.number().nullable().optional(),
    maxPlayerEntries: zod_1.z.number().nullable().optional(),
    group: zod_1.z.string().nullable().optional(),
    dispOrder: zod_1.z.number().optional(),
});
exports.zodSelectDrawTypePlan = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    drawTypeCode: zod_1.z.string(),
    code: zod_1.z.string(),
    subcode: zod_1.z.string(),
    name: zod_1.z.string(),
    desc: zod_1.z.string().nullable(),
    priceVersion: zod_1.z.number(),
    priceTable: dbJsonModels_1.ZPriceTable,
    subscriptionMaxEntries: zod_1.z.unknown(),
});
exports.zodInsertDrawTypePlan = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    drawTypeCode: zod_1.z.string(),
    code: zod_1.z.string(),
    subcode: zod_1.z.string(),
    name: zod_1.z.string(),
    desc: zod_1.z.string().nullable().optional(),
    priceVersion: zod_1.z.number().optional(),
    priceTable: dbJsonModels_1.ZPriceTable,
    subscriptionMaxEntries: zod_1.z.unknown().optional(),
});
exports.zodSelectDrawTypePlanPrizeTier = zod_1.z.object({
    drawTypePlanId: zod_1.z.number(),
    drawScheduleId: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    numberMatches: zod_1.z.number(),
    bonusNumberMatches: zod_1.z.number(),
    prizeTierId: zod_1.z.number(),
});
exports.zodInsertDrawTypePlanPrizeTier = zod_1.z.object({
    drawTypePlanId: zod_1.z.number(),
    drawScheduleId: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    numberMatches: zod_1.z.number(),
    bonusNumberMatches: zod_1.z.number(),
    prizeTierId: zod_1.z.number(),
});
exports.zodSelectEmail = zod_1.z.object({
    id: zod_1.z.string(),
    playerId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    lastModified: zod_1.z.coerce.date(),
    templateName: zod_1.z.string(),
    templateData: zod_1.z.unknown().nullable(),
    state: zod_1.z.string().nullable(),
    unsubscribed: zod_1.z.boolean().nullable(),
    brevoMessageId: zod_1.z.string().nullable(),
    brevoStatuses: zod_1.z.unknown().nullable(),
});
exports.zodInsertEmail = zod_1.z.object({
    id: zod_1.z.string(),
    playerId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    lastModified: zod_1.z.coerce.date().optional(),
    templateName: zod_1.z.string(),
    templateData: zod_1.z.unknown().nullable().optional(),
    state: zod_1.z.string().nullable().optional(),
    unsubscribed: zod_1.z.boolean().nullable().optional(),
    brevoMessageId: zod_1.z.string().nullable().optional(),
    brevoStatuses: zod_1.z.unknown().nullable().optional(),
});
exports.zodSelectFeedback = zod_1.z.object({
    id: zod_1.z.string(),
    playerId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    action: zod_1.z.nativeEnum(dbEnums_1.FeedbackAction),
    feedback: dbJsonModels_1.ZFeedbackContent,
    refKey: zod_1.z
        .enum(['prize_win', 'subscription', 'no_key'])
        .nullable(),
    refId: zod_1.z.string().nullable(),
});
exports.zodInsertFeedback = zod_1.z.object({
    id: zod_1.z.string().optional(),
    playerId: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    action: zod_1.z.nativeEnum(dbEnums_1.FeedbackAction),
    feedback: dbJsonModels_1.ZFeedbackContent,
    refKey: zod_1.z
        .enum(['prize_win', 'subscription', 'no_key'])
        .nullable()
        .optional(),
    refId: zod_1.z.string().nullable().optional(),
});
exports.zodSelectIntegratedGiftCard = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    provider: zod_1.z.string(),
    redeemCode: zod_1.z.string().nullable(),
    redeemUrl: zod_1.z.string().nullable(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    denomination: zod_1.z.number().nullable(),
    playerId: zod_1.z.string(),
    prizeOrderProductId: zod_1.z.string().nullable(),
    giveawayId: zod_1.z.string().nullable(),
    metadata: zod_1.z.unknown(),
});
exports.zodInsertIntegratedGiftCard = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    provider: zod_1.z.string(),
    redeemCode: zod_1.z.string().nullable().optional(),
    redeemUrl: zod_1.z.string().nullable().optional(),
    expiresAt: zod_1.z.coerce.date().nullable().optional(),
    denomination: zod_1.z.number().nullable().optional(),
    playerId: zod_1.z.string(),
    prizeOrderProductId: zod_1.z.string().nullable().optional(),
    giveawayId: zod_1.z.string().nullable().optional(),
    metadata: zod_1.z.unknown().optional(),
});
exports.zodSelectOrder = zod_1.z.object({
    id: zod_1.z.string(),
    playerId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    status: zod_1.z.nativeEnum(dbEnums_1.OrderStatus),
    isSubscription: zod_1.z.boolean(),
    totalFiatAmount: zod_1.z.number(),
    tokenAmount: zod_1.z.number(),
    paymentMethod: zod_1.z.nativeEnum(dbEnums_1.PaymentMethod).nullable(),
    subscriptionId: zod_1.z.string().nullable(),
    utmParams: zod_1.z.unknown().nullable(),
    attributionParams: dbJsonModels_1.ZOrderAttributionParams.nullable(),
});
exports.zodInsertOrder = zod_1.z.object({
    id: zod_1.z.string().optional(),
    playerId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.OrderStatus).optional(),
    isSubscription: zod_1.z.boolean().optional(),
    totalFiatAmount: zod_1.z.number(),
    tokenAmount: zod_1.z.number(),
    paymentMethod: zod_1.z.nativeEnum(dbEnums_1.PaymentMethod).nullable().optional(),
    subscriptionId: zod_1.z.string().nullable().optional(),
    utmParams: zod_1.z.unknown().nullable().optional(),
    attributionParams: dbJsonModels_1.ZOrderAttributionParams.nullable().optional(),
});
exports.zodSelectPaymentRequest = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    playerId: zod_1.z.string(),
    ticketIds: zod_1.z.array(zod_1.z.string()).nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.PaymentStatus),
    purchasingAction: zod_1.z.nativeEnum(dbEnums_1.PurchasingAction),
    totalFiatAmount: zod_1.z.number(),
    balanceAmount: zod_1.z.number(),
    giftCardAmount: zod_1.z.number(),
    promoAmount: zod_1.z.number(),
    tokenAmount: zod_1.z.number(),
    discountAmount: zod_1.z.number(),
    paymentMethodAmount: zod_1.z.number(),
    refType: zod_1.z.nativeEnum(dbEnums_1.PaymentRefType),
    refId: zod_1.z.string(),
    paymentMethod: zod_1.z.nativeEnum(dbEnums_1.PaymentMethod).nullable(),
    adyenPaymentSessionId: zod_1.z.string().nullable(),
    promoCode: zod_1.z.string().nullable(),
    referralId: zod_1.z.string().nullable(),
});
exports.zodInsertPaymentRequest = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    playerId: zod_1.z.string(),
    ticketIds: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PaymentStatus).optional(),
    purchasingAction: zod_1.z.nativeEnum(dbEnums_1.PurchasingAction),
    totalFiatAmount: zod_1.z.number().optional(),
    balanceAmount: zod_1.z.number().optional(),
    giftCardAmount: zod_1.z.number().optional(),
    promoAmount: zod_1.z.number().optional(),
    tokenAmount: zod_1.z.number().optional(),
    discountAmount: zod_1.z.number().optional(),
    paymentMethodAmount: zod_1.z.number().optional(),
    refType: zod_1.z.nativeEnum(dbEnums_1.PaymentRefType),
    refId: zod_1.z.string(),
    paymentMethod: zod_1.z.nativeEnum(dbEnums_1.PaymentMethod).nullable().optional(),
    adyenPaymentSessionId: zod_1.z.string().nullable().optional(),
    promoCode: zod_1.z.string().nullable().optional(),
    referralId: zod_1.z.string().nullable().optional(),
});
exports.zodSelectPlayer = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    emailAddress: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string().nullable(),
    referralId: zod_1.z.string(),
    referralLinkCopyCount: zod_1.z.number().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.PlayerStatus),
    role: zod_1.z.enum(['PLAYER', 'ADMIN', 'OPERATOR', 'STATS']),
    isWinnerManager: zod_1.z.boolean().nullable(),
    gender: zod_1.z.string().nullable(),
    dateOfBirth: zod_1.z.coerce.date().nullable(),
    interests: zod_1.z.unknown().nullable(),
    initials: zod_1.z.string().nullable(),
    treesPlanted: zod_1.z.number(),
    passwordHash: zod_1.z.string().nullable(),
    facebookUserId: zod_1.z.string().nullable(),
    googleUserId: zod_1.z.string().nullable(),
    appleUserId: zod_1.z.string().nullable(),
    utmParameters: zod_1.z.unknown().nullable(),
    metadata: zod_1.z.unknown().nullable(),
    abtestVariants: dbJsonModels_1.ZPlayerABTestVariant.nullable(),
    avatarLocation: zod_1.z.string().nullable(),
    friendlyName: zod_1.z.string().nullable(),
    searchFullName: zod_1.z.string().nullable(),
    searchEmail: zod_1.z.string().nullable(),
    reviewedOnTrustpilot: zod_1.z.boolean(),
    reviewedOnFacebook: zod_1.z.boolean(),
    reviewedOnGoogle: zod_1.z.boolean(),
    followedOnInstagram: zod_1.z.boolean(),
    filledInSurvey: zod_1.z.boolean(),
    firstPurchaseTicketId: zod_1.z.string().nullable(),
    lastPurchaseTicketId: zod_1.z.string().nullable(),
    totalSpend: zod_1.z.number().nullable(),
    suspended: zod_1.z.boolean().nullable(),
    frozen: zod_1.z.boolean(),
    spendLimitPence: zod_1.z.number().nullable(),
    lastActivityAt: zod_1.z.coerce.date().nullable(),
});
exports.zodInsertPlayer = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    emailAddress: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string().nullable().optional(),
    referralId: zod_1.z.string(),
    referralLinkCopyCount: zod_1.z.number().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PlayerStatus).optional(),
    role: zod_1.z
        .enum(['PLAYER', 'ADMIN', 'OPERATOR', 'STATS'])
        .optional(),
    isWinnerManager: zod_1.z.boolean().nullable().optional(),
    gender: zod_1.z.string().nullable().optional(),
    dateOfBirth: zod_1.z.coerce.date().nullable().optional(),
    interests: zod_1.z.unknown().nullable().optional(),
    initials: zod_1.z.string().nullable().optional(),
    treesPlanted: zod_1.z.number().optional(),
    passwordHash: zod_1.z.string().nullable().optional(),
    facebookUserId: zod_1.z.string().nullable().optional(),
    googleUserId: zod_1.z.string().nullable().optional(),
    appleUserId: zod_1.z.string().nullable().optional(),
    utmParameters: zod_1.z.unknown().nullable().optional(),
    metadata: zod_1.z.unknown().nullable().optional(),
    abtestVariants: dbJsonModels_1.ZPlayerABTestVariant.nullable().optional(),
    avatarLocation: zod_1.z.string().nullable().optional(),
    friendlyName: zod_1.z.string().nullable().optional(),
    searchFullName: zod_1.z.string().nullable().optional(),
    searchEmail: zod_1.z.string().nullable().optional(),
    reviewedOnTrustpilot: zod_1.z.boolean().optional(),
    reviewedOnFacebook: zod_1.z.boolean().optional(),
    reviewedOnGoogle: zod_1.z.boolean().optional(),
    followedOnInstagram: zod_1.z.boolean().optional(),
    filledInSurvey: zod_1.z.boolean().optional(),
    firstPurchaseTicketId: zod_1.z.string().nullable().optional(),
    lastPurchaseTicketId: zod_1.z.string().nullable().optional(),
    totalSpend: zod_1.z.number().nullable().optional(),
    suspended: zod_1.z.boolean().nullable().optional(),
    frozen: zod_1.z.boolean().optional(),
    spendLimitPence: zod_1.z.number().nullable().optional(),
    lastActivityAt: zod_1.z.coerce.date().nullable().optional(),
});
exports.zodSelectPlayerIPAddressLog = zod_1.z.object({
    id: zod_1.z.number(),
    ipAddress: zod_1.z.string(),
    playerId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    lastSeenAt: zod_1.z.coerce.date(),
});
exports.zodInsertPlayerIPAddressLog = zod_1.z.object({
    id: zod_1.z.number().optional(),
    ipAddress: zod_1.z.string(),
    playerId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    lastSeenAt: zod_1.z.coerce.date().optional(),
});
exports.zodSelectPlayerPreferences = zod_1.z.object({
    playerId: zod_1.z.string(),
    agreedToMarketing: zod_1.z.boolean(),
    drawReminderEmails: zod_1.z.boolean().nullable(),
    dprReminders: zod_1.z.boolean().nullable(),
    notifyResults: zod_1.z.boolean(),
    notifyResultsDailyChallenger: zod_1.z.boolean().nullable(),
    notifyResultsLeaderboard: zod_1.z.boolean().nullable(),
    notifyResultsRaffles: zod_1.z.boolean().nullable(),
    notifyResultsMinilottos: zod_1.z.boolean().nullable(),
});
exports.zodInsertPlayerPreferences = zod_1.z.object({
    playerId: zod_1.z.string(),
    agreedToMarketing: zod_1.z.boolean().optional(),
    drawReminderEmails: zod_1.z.boolean().nullable().optional(),
    dprReminders: zod_1.z.boolean().nullable().optional(),
    notifyResults: zod_1.z.boolean().optional(),
    notifyResultsDailyChallenger: zod_1.z.boolean().nullable().optional(),
    notifyResultsLeaderboard: zod_1.z.boolean().nullable().optional(),
    notifyResultsRaffles: zod_1.z.boolean().nullable().optional(),
    notifyResultsMinilottos: zod_1.z.boolean().nullable().optional(),
});
exports.zodSelectPrize = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeStatus),
    title: zod_1.z.string(),
    subheading: zod_1.z.string(),
    type: zod_1.z.nativeEnum(dbEnums_1.PrizeType),
    slug: zod_1.z.string(),
    imageLocations: zod_1.z.unknown(),
    overviewBody: zod_1.z.string().nullable(),
    whatsIncludedHeading: zod_1.z.string().nullable(),
    whatsIncludedBody: zod_1.z.string(),
    internalInfo: zod_1.z.unknown(),
    requiresDeliveryAddress: zod_1.z.boolean().nullable(),
    requiresEmailAddress: zod_1.z.boolean().nullable(),
    requiresPhoneNumber: zod_1.z.boolean().nullable(),
    additionalQuestionsForPlayer: zod_1.z.unknown(),
    seoMetaTitle: zod_1.z.string().nullable(),
    seoMetaDescription: zod_1.z.string().nullable(),
    seoKeywords: zod_1.z.string(),
    seoImageAltText: zod_1.z.unknown(),
    isFromPlayersSuggestion: zod_1.z.boolean().nullable(),
    followUpEmailDelayInDays: zod_1.z.number().nullable(),
    subscriberDiscountContentCode: zod_1.z.string().nullable(),
    vendorCategory: zod_1.z.nativeEnum(dbEnums_1.VendorCategory).nullable(),
    vendorName: zod_1.z.string().nullable(),
    legacyPrizeValue: zod_1.z.number().nullable(),
    searchVector: zod_1.z.any(),
});
exports.zodInsertPrize = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeStatus),
    title: zod_1.z.string(),
    subheading: zod_1.z.string(),
    type: zod_1.z.nativeEnum(dbEnums_1.PrizeType),
    slug: zod_1.z.string(),
    imageLocations: zod_1.z.unknown(),
    overviewBody: zod_1.z.string().nullable().optional(),
    whatsIncludedHeading: zod_1.z.string().nullable().optional(),
    whatsIncludedBody: zod_1.z.string(),
    internalInfo: zod_1.z.unknown().optional(),
    requiresDeliveryAddress: zod_1.z.boolean().nullable().optional(),
    requiresEmailAddress: zod_1.z.boolean().nullable().optional(),
    requiresPhoneNumber: zod_1.z.boolean().nullable().optional(),
    additionalQuestionsForPlayer: zod_1.z.unknown().optional(),
    seoMetaTitle: zod_1.z.string().nullable().optional(),
    seoMetaDescription: zod_1.z.string().nullable().optional(),
    seoKeywords: zod_1.z.string(),
    seoImageAltText: zod_1.z.unknown(),
    isFromPlayersSuggestion: zod_1.z.boolean().nullable().optional(),
    followUpEmailDelayInDays: zod_1.z.number().nullable().optional(),
    subscriberDiscountContentCode: zod_1.z.string().nullable().optional(),
    vendorCategory: zod_1.z.nativeEnum(dbEnums_1.VendorCategory).nullable().optional(),
    vendorName: zod_1.z.string().nullable().optional(),
    legacyPrizeValue: zod_1.z.number().nullable().optional(),
    searchVector: zod_1.z.any().optional(),
});
exports.zodSelectPrizeTier = zod_1.z.object({
    id: zod_1.z.number(),
    prizeStructureId: zod_1.z.number(),
    code: zod_1.z.string(),
    legacyPrizeValue: zod_1.z.number().nullable(),
    imageLink: zod_1.z.string().nullable(),
    type: zod_1.z.nativeEnum(dbEnums_1.PrizeTierType),
});
exports.zodInsertPrizeTier = zod_1.z.object({
    id: zod_1.z.number().optional(),
    prizeStructureId: zod_1.z.number(),
    code: zod_1.z.string(),
    legacyPrizeValue: zod_1.z.number().nullable().optional(),
    imageLink: zod_1.z.string().nullable().optional(),
    type: zod_1.z.nativeEnum(dbEnums_1.PrizeTierType),
});
exports.zodSelectProductCatalog = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.ProductStatus),
    type: zod_1.z.nativeEnum(dbEnums_1.ProductType),
    autoFulfilmentCode: zod_1.z.string().nullable(),
    autoFulfilmentDetail: zod_1.z.unknown(),
    imageLocation: zod_1.z.string().nullable(),
    price: zod_1.z.number().nullable(),
    internalName: zod_1.z.string().nullable(),
    productCode: zod_1.z.string().nullable(),
    discountCode: zod_1.z.string().nullable(),
    purchaseFrom: zod_1.z.string().nullable(),
    orderForm: zod_1.z.string().nullable(),
});
exports.zodInsertProductCatalog = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.ProductStatus).optional(),
    type: zod_1.z.nativeEnum(dbEnums_1.ProductType),
    autoFulfilmentCode: zod_1.z.string().nullable().optional(),
    autoFulfilmentDetail: zod_1.z.unknown().optional(),
    imageLocation: zod_1.z.string().nullable().optional(),
    price: zod_1.z.number().nullable().optional(),
    internalName: zod_1.z.string().nullable().optional(),
    productCode: zod_1.z.string().nullable().optional(),
    discountCode: zod_1.z.string().nullable().optional(),
    purchaseFrom: zod_1.z.string().nullable().optional(),
    orderForm: zod_1.z.string().nullable().optional(),
});
exports.zodSelectPromoCode = zod_1.z.object({
    code: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.PromoStatus),
    description: zod_1.z.string(),
    banner: zod_1.z.string().nullable(),
    promoType: zod_1.z.nativeEnum(dbEnums_1.PromoType),
    allowMulti: zod_1.z.boolean(),
    playerSpecific: zod_1.z.boolean(),
    action: zod_1.z.nativeEnum(dbEnums_1.PromoAction).nullable(),
    conditions: dbJsonModels_1.ZPromoConditions.nullable(),
    rewardType: zod_1.z.nativeEnum(dbEnums_1.RewardType),
    rewardValue: zod_1.z.number(),
    rewardCount: zod_1.z.number(),
});
exports.zodInsertPromoCode = zod_1.z.object({
    code: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    expiresAt: zod_1.z.coerce.date().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PromoStatus).optional(),
    description: zod_1.z.string(),
    banner: zod_1.z.string().nullable().optional(),
    promoType: zod_1.z.nativeEnum(dbEnums_1.PromoType),
    allowMulti: zod_1.z.boolean().optional(),
    playerSpecific: zod_1.z.boolean().optional(),
    action: zod_1.z.nativeEnum(dbEnums_1.PromoAction).nullable().optional(),
    conditions: dbJsonModels_1.ZPromoConditions.nullable().optional(),
    rewardType: zod_1.z.nativeEnum(dbEnums_1.RewardType),
    rewardValue: zod_1.z.number(),
    rewardCount: zod_1.z.number(),
});
exports.zodSelectPromoCodeRecurring = zod_1.z.object({
    id: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.PromoRecurringStatus),
    code: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    playerId: zod_1.z.string(),
    subscriptionId: zod_1.z.string().nullable(),
    remainingCount: zod_1.z.number(),
});
exports.zodInsertPromoCodeRecurring = zod_1.z.object({
    id: zod_1.z.string().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PromoRecurringStatus).optional(),
    code: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    playerId: zod_1.z.string(),
    subscriptionId: zod_1.z.string().nullable().optional(),
    remainingCount: zod_1.z.number(),
});
exports.zodSelectPromoPrizeReward = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    code: zod_1.z.string(),
    playerId: zod_1.z.string(),
    prizeId: zod_1.z.number(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    chosenAt: zod_1.z.coerce.date().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.PromoPrizeRewardStatus),
    refKey: zod_1.z.nativeEnum(dbEnums_1.PromoPrizeRewardRefKey).nullable(),
    refId: zod_1.z.string().nullable(),
});
exports.zodInsertPromoPrizeReward = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    code: zod_1.z.string(),
    playerId: zod_1.z.string(),
    prizeId: zod_1.z.number(),
    expiresAt: zod_1.z.coerce.date().nullable().optional(),
    chosenAt: zod_1.z.coerce.date().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PromoPrizeRewardStatus).optional(),
    refKey: zod_1.z.nativeEnum(dbEnums_1.PromoPrizeRewardRefKey).nullable().optional(),
    refId: zod_1.z.string().nullable().optional(),
});
exports.zodSelectPrizeOrder = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    prizeWinId: zod_1.z.string().nullable(),
    orderId: zod_1.z.string().nullable(),
    promoPrizeRewardId: zod_1.z.string().nullable(),
    prizeId: zod_1.z.number(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeOrderStatus),
    deliveryStreet: zod_1.z.string().nullable(),
    deliveryCity: zod_1.z.string().nullable(),
    deliveryPostcode: zod_1.z.string().nullable(),
    emailAddress: zod_1.z.string().nullable(),
    phoneNumber: zod_1.z.string().nullable(),
    additionalInfoFromPlayer: zod_1.z.unknown(),
    assigneeId: zod_1.z.string().nullable(),
    confirmedAt: zod_1.z.coerce.date().nullable(),
    confirmedBy: zod_1.z.string().nullable(),
});
exports.zodInsertPrizeOrder = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    prizeWinId: zod_1.z.string().nullable().optional(),
    orderId: zod_1.z.string().nullable().optional(),
    promoPrizeRewardId: zod_1.z.string().nullable().optional(),
    prizeId: zod_1.z.number(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeOrderStatus).optional(),
    deliveryStreet: zod_1.z.string().nullable().optional(),
    deliveryCity: zod_1.z.string().nullable().optional(),
    deliveryPostcode: zod_1.z.string().nullable().optional(),
    emailAddress: zod_1.z.string().nullable().optional(),
    phoneNumber: zod_1.z.string().nullable().optional(),
    additionalInfoFromPlayer: zod_1.z.unknown().optional(),
    assigneeId: zod_1.z.string().nullable().optional(),
    confirmedAt: zod_1.z.coerce.date().nullable().optional(),
    confirmedBy: zod_1.z.string().nullable().optional(),
});
exports.zodSelectPrizeOrderProduct = zod_1.z.object({
    id: zod_1.z.string(),
    prizeOrderId: zod_1.z.string(),
    productId: zod_1.z.number(),
    quantity: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    awardedAt: zod_1.z.coerce.date().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeOrderStatus),
    orderNumber: zod_1.z.string().nullable(),
    trackingNumber: zod_1.z.string().nullable(),
});
exports.zodInsertPrizeOrderProduct = zod_1.z.object({
    id: zod_1.z.string().optional(),
    prizeOrderId: zod_1.z.string(),
    productId: zod_1.z.number(),
    quantity: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    awardedAt: zod_1.z.coerce.date().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeOrderStatus).optional(),
    orderNumber: zod_1.z.string().nullable().optional(),
    trackingNumber: zod_1.z.string().nullable().optional(),
});
exports.zodSelectPrizeWin = zod_1.z.object({
    id: zod_1.z.string(),
    ticketEntryId: zod_1.z.string(),
    prizeTierId: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    chosenAt: zod_1.z.coerce.date().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeWinStatus),
    prizeOrderId: zod_1.z.string().nullable(),
    notes: zod_1.z.string().nullable(),
    legacyPrizeChoice: zod_1.z.unknown().nullable(),
});
exports.zodInsertPrizeWin = zod_1.z.object({
    id: zod_1.z.string().optional(),
    ticketEntryId: zod_1.z.string(),
    prizeTierId: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    expiresAt: zod_1.z.coerce.date().nullable().optional(),
    chosenAt: zod_1.z.coerce.date().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.PrizeWinStatus).optional(),
    prizeOrderId: zod_1.z.string().nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
    legacyPrizeChoice: zod_1.z.unknown().nullable().optional(),
});
exports.zodSelectSubscription = zod_1.z.object({
    id: zod_1.z.string(),
    playerId: zod_1.z.string(),
    orderId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    status: zod_1.z.nativeEnum(dbEnums_1.SubscriptionStatus),
    startDate: zod_1.z.coerce.date(),
    paymentDow: zod_1.z.number(),
    nextPaymentDate: zod_1.z.coerce.date(),
    recurringPaymentToken: zod_1.z.string().nullable(),
    currentRun: zod_1.z.number().nullable(),
    failureCount: zod_1.z.number(),
    failedAt: zod_1.z.coerce.date().nullable(),
    cancelledAt: zod_1.z.coerce.date().nullable(),
    snoozedUntil: zod_1.z.coerce.date().nullable(),
    version: zod_1.z.number(),
});
exports.zodInsertSubscription = zod_1.z.object({
    id: zod_1.z.string().optional(),
    playerId: zod_1.z.string(),
    orderId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.SubscriptionStatus).optional(),
    startDate: zod_1.z.coerce.date(),
    paymentDow: zod_1.z.number(),
    nextPaymentDate: zod_1.z.coerce.date(),
    recurringPaymentToken: zod_1.z.string().nullable().optional(),
    currentRun: zod_1.z.number().nullable().optional(),
    failureCount: zod_1.z.number().optional(),
    failedAt: zod_1.z.coerce.date().nullable().optional(),
    cancelledAt: zod_1.z.coerce.date().nullable().optional(),
    snoozedUntil: zod_1.z.coerce.date().nullable().optional(),
    version: zod_1.z.number().optional(),
});
exports.zodSelectSubscriptionHistory = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    lastModified: zod_1.z.coerce.date(),
    subscriptionId: zod_1.z.string(),
    action: zod_1.z.string(),
    additionalInfo: dbJsonModels_1.ZSubscriptionHistoryAdditionalInfo.nullable(),
});
exports.zodInsertSubscriptionHistory = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    lastModified: zod_1.z.coerce.date().optional(),
    subscriptionId: zod_1.z.string(),
    action: zod_1.z.string(),
    additionalInfo: dbJsonModels_1.ZSubscriptionHistoryAdditionalInfo.nullable().optional(),
});
exports.zodSelectSubscriptionRun = zod_1.z.object({
    id: zod_1.z.string(),
    playerId: zod_1.z.string().nullable(),
    subscriptionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    status: zod_1.z.nativeEnum(dbEnums_1.SubscriptionRunStatus),
    runNumber: zod_1.z.number(),
    drawOrderId: zod_1.z.string().nullable(),
});
exports.zodInsertSubscriptionRun = zod_1.z.object({
    id: zod_1.z.string().optional(),
    playerId: zod_1.z.string().nullable().optional(),
    subscriptionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.SubscriptionRunStatus).optional(),
    runNumber: zod_1.z.number(),
    drawOrderId: zod_1.z.string().nullable().optional(),
});
exports.zodSelectTreeLog = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    playerId: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.TreeStatus),
    action: zod_1.z.nativeEnum(dbEnums_1.TreeAction),
    refId: zod_1.z.string(),
    refKey: zod_1.z.nativeEnum(dbEnums_1.TreeRefKey),
    orderId: zod_1.z.string().nullable(),
    quantity: zod_1.z.number(),
    additionalInfo: zod_1.z.unknown().nullable(),
});
exports.zodInsertTreeLog = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    playerId: zod_1.z.string(),
    status: zod_1.z.nativeEnum(dbEnums_1.TreeStatus),
    action: zod_1.z.nativeEnum(dbEnums_1.TreeAction),
    refId: zod_1.z.string(),
    refKey: zod_1.z.nativeEnum(dbEnums_1.TreeRefKey),
    orderId: zod_1.z.string().nullable().optional(),
    quantity: zod_1.z.number(),
    additionalInfo: zod_1.z.unknown().nullable().optional(),
});
exports.zodSelectTicket = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    status: zod_1.z.nativeEnum(dbEnums_1.TicketStatus),
    paymentRequestId: zod_1.z.string(),
    drawOrderId: zod_1.z.string(),
    cost: zod_1.z.number().nullable(),
    discount: zod_1.z.number().nullable(),
    paid: zod_1.z.number().nullable(),
    token: zod_1.z.number().nullable(),
    drawId: zod_1.z.number(),
    drawTypePlanId: zod_1.z.number(),
    playerId: zod_1.z.string(),
    cancelledReason: zod_1.z.string().nullable(),
    cancelledAt: zod_1.z.coerce.date().nullable(),
    cancelledBy: zod_1.z.string().nullable(),
});
exports.zodInsertTicket = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.TicketStatus).optional(),
    paymentRequestId: zod_1.z.string(),
    drawOrderId: zod_1.z.string(),
    cost: zod_1.z.number().nullable().optional(),
    discount: zod_1.z.number().nullable().optional(),
    paid: zod_1.z.number().nullable().optional(),
    token: zod_1.z.number().nullable().optional(),
    drawId: zod_1.z.number(),
    drawTypePlanId: zod_1.z.number(),
    playerId: zod_1.z.string(),
    cancelledReason: zod_1.z.string().nullable().optional(),
    cancelledAt: zod_1.z.coerce.date().nullable().optional(),
    cancelledBy: zod_1.z.string().nullable().optional(),
});
exports.zodSelectTicketEntry = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    ticketId: zod_1.z.string(),
    entry: zod_1.z.unknown(),
    resultNumberMatches: zod_1.z.number().nullable(),
    resultBonusNumberMatches: zod_1.z.number().nullable(),
});
exports.zodInsertTicketEntry = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    ticketId: zod_1.z.string(),
    entry: zod_1.z.unknown(),
    resultNumberMatches: zod_1.z.number().nullable().optional(),
    resultBonusNumberMatches: zod_1.z.number().nullable().optional(),
});
exports.zodSelectTokenOrder = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    playerId: zod_1.z.string(),
    orderId: zod_1.z.string(),
    tokenAmount: zod_1.z.number(),
    status: zod_1.z.nativeEnum(dbEnums_1.TokenOrderStatus),
});
exports.zodInsertTokenOrder = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    playerId: zod_1.z.string(),
    orderId: zod_1.z.string(),
    tokenAmount: zod_1.z.number(),
    status: zod_1.z.nativeEnum(dbEnums_1.TokenOrderStatus).optional(),
});
exports.zodSelectTokenRedemption = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    playerId: zod_1.z.string(),
    tokenRedemptionOptionId: zod_1.z.number(),
    orderId: zod_1.z.string().nullable(),
    status: zod_1.z.nativeEnum(dbEnums_1.TokenRedemptionStatus),
    notes: zod_1.z.string().nullable(),
});
exports.zodInsertTokenRedemption = zod_1.z.object({
    id: zod_1.z.string().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    playerId: zod_1.z.string(),
    tokenRedemptionOptionId: zod_1.z.number(),
    orderId: zod_1.z.string().nullable().optional(),
    status: zod_1.z.nativeEnum(dbEnums_1.TokenRedemptionStatus).optional(),
    notes: zod_1.z.string().nullable().optional(),
});
exports.zodSelectTokenRedemptionOption = zod_1.z.object({
    id: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    code: zod_1.z.string(),
    slug: zod_1.z.string(),
    type: zod_1.z.nativeEnum(dbEnums_1.TokenRedemptionOptionType),
    prizeTierId: zod_1.z.number().nullable(),
    drawTypePlanId: zod_1.z.number().nullable(),
    price: zod_1.z.number(),
    status: zod_1.z.nativeEnum(dbEnums_1.TokenRedemptionOptionStatus),
    title: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    heroImage: zod_1.z.string().nullable(),
    group: zod_1.z.string().nullable(),
    groupOrder: zod_1.z.number().nullable(),
});
exports.zodInsertTokenRedemptionOption = zod_1.z.object({
    id: zod_1.z.number().optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    code: zod_1.z.string(),
    slug: zod_1.z.string(),
    type: zod_1.z.nativeEnum(dbEnums_1.TokenRedemptionOptionType),
    prizeTierId: zod_1.z.number().nullable().optional(),
    drawTypePlanId: zod_1.z.number().nullable().optional(),
    price: zod_1.z.number(),
    status: zod_1.z.nativeEnum(dbEnums_1.TokenRedemptionOptionStatus).optional(),
    title: zod_1.z.string().nullable().optional(),
    description: zod_1.z.string().nullable().optional(),
    heroImage: zod_1.z.string().nullable().optional(),
    group: zod_1.z.string().nullable().optional(),
    groupOrder: zod_1.z.number().nullable().optional(),
});
//# sourceMappingURL=zodSchemas.generated.js.map